module.exports = __webpack_public_path__ + "img/Monte_Kope_113.e5fbf785.jpg";